import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_TABLE_CELL__inputs__field_role({ field }: PROPS) {
  let role_exist = !field.meta.field_role.is_blank();

  let text = role_exist ? field.meta.field_role : field.meta.field_path;

  return (
    <div className="flex items-center space-x-2 ">
      <span className={`${role_exist ? '' : 'opacity-50'}`}>{text}</span>
      <button type="button" className="text-xs text-blue-600 hover:underline">
        Edit
      </button>
    </div>
  );
}
